import Thumbnail from '../thumbnail/thumbnail';

export default class Work {
  constructor() {
    this.section = document.getElementById('s-work');
  }

  init = () => {
    this.thumbnail = new Thumbnail;
    this.thumbnail.init();
  }

  destroy = () => {
    this.thumbnail.destroy();
  }
}
